import React, { useState } from "react";
import "../styles/ProductCard.css";
import { useEffect } from "react";

const ProductCard = ({ product, onRemove }) => {
console.log(product)
  const [productLink, setProductLink] = useState();

  useEffect(() => {
    switch (product.metadata.ref) {
      case "B01":
        setProductLink('/product/boitier-multifonction-securite-velo-trottinette-b01')
        break;
      case "H01":
        setProductLink('/product/casque-intelligent-lumineux-h01')
        break;
      case "B01LITE":
        setProductLink('/product/boitier-multifonction-securite-velo-trottinette-b01-lite/BLACK')
        break;
    
      default:
        break;
    }
    // eslint-disable-next-line
  }, []);

  const getPriceInEuros = (cents) => {
    if (!cents) return "0.00";
    return (cents / 100).toFixed(2);
  };

  let displayContent;

  // Cas 1 : LLD présente
  if (product.lld) {
    displayContent = (
      <div>
        <p className="product-installment">
          LLD : {product.lld.monthPrice} € / mois
        </p>
        <p className="product-eco-fee">
          Premier paiement : {product.lld.initPrice} €
        </p>
      </div>
    );

  // Cas 2 : Achat direct (type = one_time)
  } else if (product.price?.type === "one_time") {
    const oneTimePrice = getPriceInEuros(product.price.unit_amount);
    displayContent = (
      <div>
        <p className="product-price"><span style={{fontWeight: 'bold', fontSize: 18}}>Prix : </span>
        {product.price.metadata.init_price && (
          <span>
            <span
            style={{
              color: "#333",
              opacity: 0.8,
              margin: 0,
            }}
          >
            <span style={{ textDecorationLine: "line-through" }}>
              {product.price.metadata.init_price} €
            </span>
            </span>
            <span style={{fontWeight: 'bold', color: "#4FB897" }}>
            &nbsp;-{(parseFloat(product.price.metadata.init_price)-parseInt(oneTimePrice)).toFixed(2)}&nbsp;€ 
            </span>
            &nbsp;|
          </span>
        )}
        <span style={{fontWeight: 'bold', fontSize: 18}}>&nbsp;{oneTimePrice} €</span></p>
        {product.metadata.promo_date && product.price.metadata.init_price ? <p style={{fontWeight: 'bold', color: '#FFF', backgroundColor: "#333", padding: '10px 15px', borderRadius: 50}}>Promotion jusqu'au {product.metadata.promo_date}</p> : null}
        
      </div>
    );

  // Cas 3 : Abonnement (type = recurring)
  } else if (product.price?.type === "recurring") {
    const monthlyCost = getPriceInEuros(product.price.unit_amount);
    const activationFee = product.price.metadata?.activation_fees
      ? parseFloat(product.price.metadata.activation_fees).toFixed(2)
      : "0.00";

    displayContent = (
      <div>
        <p className="product-price">Mensuel : {monthlyCost} € / mois</p>
        {parseFloat(activationFee) > 0 && (
          <div>
            <p className="product-price">
              Frais d’activation : {activationFee} €
            </p>
            <p ><strong>Sans angagement, vous pouvez résilier à tout moment.</strong></p>
          </div>
        )}
      </div>
    );

  // Cas 4 : Fallback
  } else {
    displayContent = (
      <p className="product-price">Type de produit inconnu</p>
    );
  }

  return (
    <div className="product-card">
      {/** IMAGE + NOM DU PRODUIT */}
      <img
        src={"https://www.balteemobility.com/ecommerce-cache-assets/stripe/images/products/"+product.productId}
        alt={product.name}
        className="CartProduct_product-image"
      />

      {productLink ? <h3 className="product-name"><a href={productLink} style={{color: '#000'}}>{product.name}</a></h3> : <h3 className="product-name">{product.name}</h3>}
     {product.metadata.selectedSize ?  <h4 className="product-name">Taille : {product.metadata.selectedSize}</h4> : null}

      {/** CONTENU SPÉCIFIQUE SELON LE TYPE DE PRODUIT */}
      {displayContent}

      {/**
       * Éco-participation (si elle existe dans l'objet produit)
       * Vous pouvez aussi la conditionner si vous ne l'avez que pour certains items
       */}
      {product.ecoFee !== undefined && (
        <p className="product-eco-fee">
          Éco-participation : {product.ecoFee} €
        </p>
      )}

      {/** BOUTON SUPPRIMER */}
      <button
        onClick={() => onRemove(product.id)}
        className="remove-button"
      >
        Supprimer
      </button>
    </div>
  );
};

export default ProductCard;
